// Classify the shell without changing the URL used by public displays.
export const getRouteLayout = (pathname, isAuthenticated) => {
    const normalizedPath = pathname.replace(/\/+$/, '') || '/';
    const isPricingPage = normalizedPath === '/pricing';
    const isLoginPage = normalizedPath === '/login';
    const isLegalPage = normalizedPath === '/privacy-policy' ||
        normalizedPath === '/general-conditions';
    const isMarketingHome = normalizedPath === '/' && !isAuthenticated;
    const isPublicPage = normalizedPath.startsWith('/streaming/') ||
        normalizedPath.startsWith('/scoreboard/') ||
        normalizedPath.startsWith('/public/queue') ||
        normalizedPath.startsWith('/play/') ||
        normalizedPath.startsWith('/player/') ||
        isLegalPage;
    const showClubHeader = isAuthenticated && !isPublicPage && !isPricingPage && !isLoginPage;

    return {
        isClubPanelPage: showClubHeader,
        showClubHeader,
        showFooter: !isPublicPage && !isPricingPage && !isMarketingHome && !isLoginPage,
    };
};
